"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _formatMessage = _interopRequireDefault(require("../format-message"));

/*
 * Copyright (C) 2018 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */
var locale = {
  alternative_text_a834dcad: {
    message: "Valfrj\xE1ls texti:"
  },
  announcement_list_da155734: {
    message: "Tilkynningalisti"
  },
  announcements_a4b8ed4a: {
    message: "Tilkynningar"
  },
  assignments_1e02582c: {
    message: "Verkefni"
  },
  background_color_press_down_to_select_ef99fdac: {
    message: "Bakgrunnslitur, \xFDti\xF0 ni\xF0ur til a\xF0 velja"
  },
  c_2001_acme_inc_283f7f80: {
    message: "(C) 2001 Acme Inc."
  },
  cancel_file_upload_9903e7b9: {
    message: "H\xE6tta vi\xF0 a\xF0 hla\xF0a upp skr\xE1"
  },
  cancel_image_upload_2c771950: {
    message: "H\xE6tta vi\xF0 a\xF0 hla\xF0a upp mynd"
  },
  cc_attribution_f6de631f: {
    message: "CC eigind"
  },
  cc_attribution_no_derivatives_b006744f: {
    message: "CC n\xFDting \xE1n aflei\xF0a"
  },
  cc_attribution_non_commercial_39e0d30d: {
    message: "CC eigind , ekki \xED vi\xF0skiptalegum tilgangi"
  },
  cc_attribution_non_commercial_no_derivatives_9fe74c00: {
    message: "CC n\xFDting \xE1n aflei\xF0a, ekki \xED vi\xF0skiptalegum tilgangi"
  },
  cc_attribution_non_commercial_share_alike_c7edb1e5: {
    message: "CC n\xFDting me\xF0 samdeilingu, ekki \xED vi\xF0skiptalegum tilgangi"
  },
  cc_attribution_share_alike_669e7f16: {
    message: "CC eigind me\xF0 samdeilingu"
  },
  check_if_the_image_is_decorative_283649b7: {
    message: "Athuga\xF0u hvort myndin er skreyting"
  },
  choose_usage_rights_33683854: {
    message: "Velja notkunarr\xE9ttindi..."
  },
  click_any_file_to_insert_a_download_link_for_that__a708fa4c: {
    message: "Smelltu \xE1 hva\xF0a skr\xE1 sem er til a\xF0 setja inn tengil til a\xF0 s\xE6kja skr\xE1na."
  },
  click_any_image_to_embed_the_image_in_the_page_2cdd1136: {
    message: "Smelli\xF0 \xE1 hva\xF0a mynd sem er til a\xF0 \xEDvefja myndina \xE1 s\xED\xF0una."
  },
  click_any_page_to_insert_a_link_to_that_page_ac920c02: {
    message: "Smelli\xF0 \xE1 hva\xF0a s\xED\xF0u sem er til a\xF0 setja inn tengil \xE1 \xFE\xE1 s\xED\xF0u."
  },
  click_to_embed_image_33107dd8: {
    message: "Smella til a\xF0 \xEDvefja mynd"
  },
  click_to_embed_imagename_c41ea8df: {
    message: "Smella til a\xF0 \xEDvefja { imageName }"
  },
  click_to_insert_a_link_into_the_editor_c19613aa: {
    message: "Smelli\xF0 til a\xF0 setja tengil inn \xED ritilinn."
  },
  click_to_insert_a_link_to_this_item_39794098: {
    message: "Smelli\xF0 til a\xF0 setja inn tengil \xE1 \xFEetta atri\xF0i."
  },
  close_flickr_form_b32e600a: {
    message: "Loka Flickr-formi"
  },
  collaborations_5c56c15f: {
    message: "Samvinnut\xF3l"
  },
  copyright_holder_66ee111: {
    message: "Handhafi h\xF6fundarr\xE9ttar:"
  },
  course_navigation_dd035109: {
    message: "Lei\xF0arnet n\xE1mskei\xF0s"
  },
  creative_commons_license_725584ae: {
    message: "Creative Commons-leyfi:"
  },
  decorative_image_fde98579: {
    message: "Skreytingarmynd"
  },
  discussions_a5f96392: {
    message: "Umr\xE6\xF0ur"
  },
  discussions_index_6c36ced: {
    message: "Umr\xE6\xF0uv\xEDsir"
  },
  embed_image_1080badc: {
    message: "\xCDvefja mynd"
  },
  enter_search_terms_e397b1f0: {
    message: "sl\xE1 inn leitaror\xF0"
  },
  enter_the_alternative_text_for_this_image_88047c47: {
    message: "Settu inn \xFEann texta sem \xFE\xFA k\xFDst vi\xF0 \xFEessa mynd"
  },
  file_upload_form_4aaad554: {
    message: "Form fyrir upphle\xF0slu skr\xE1ar"
  },
  files_c300e900: {
    message: "Skr\xE1r"
  },
  files_index_af7c662b: {
    message: "Skr\xE1av\xEDsir"
  },
  folder_705fd2d7: {
    message: "Mappa"
  },
  font_size_press_down_to_select_6c25dc2d: {
    message: "Leturst\xE6r\xF0, \xFDti\xF0 ni\xF0ur til a\xF0 velja"
  },
  formatting_press_down_to_select_df728c30: {
    message: "Er a\xF0 sn\xED\xF0a, \xFDti\xF0 ni\xF0ur til a\xF0 velja"
  },
  grades_a61eba0a: {
    message: "Einkunnir"
  },
  group_navigation_99f191a: {
    message: "H\xF3plei\xF0arst\xFDring"
  },
  i_have_obtained_permission_to_use_this_file_6386f087: {
    message: "\xC9g hef feng\xF0 leyfi til a\xF0 nota \xFEessa skr\xE1."
  },
  i_hold_the_copyright_71ee91b1: {
    message: "\xC9g er me\xF0 h\xF6fundarr\xE9ttinn"
  },
  if_you_do_not_select_usage_rights_now_this_file_wi_14e07ab5: {
    message: "Ef \xFE\xFA velur ekki notkunarr\xE9ttindi n\xFAna ver\xF0ur \xFEessi skr\xE1 \xF3birt eftir a\xF0 henni hefur veri\xF0 hla\xF0i\xF0 upp."
  },
  image_upload_form_7b74079a: {
    message: "Form myndar \xED upphle\xF0slu"
  },
  images_7ce26570: {
    message: "Myndir"
  },
  insert_equella_links_49a8dacd: {
    message: "Setja inn Equella tengla"
  },
  insert_link_6dc23cae: {
    message: "Setja inn tengil"
  },
  insert_math_equation_57c6e767: {
    message: "Setja inn st\xE6r\xF0fr\xE6\xF0ij\xF6fnu"
  },
  link_7262adec: {
    message: "Tengill "
  },
  link_to_a_new_page_6c4ad034: {
    message: "Tengill \xE1 n\xFDja s\xED\xF0u"
  },
  link_to_other_content_in_the_course_879163b5: {
    message: "Setja inn tengil \xE1 anna\xF0 efni \xED n\xE1mskei\xF0inu."
  },
  link_to_other_content_in_the_group_3fe25379: {
    message: "Tengill \xE1 anna\xF0 efni \xED h\xF3pnum."
  },
  link_to_url_52dd935c: {
    message: "Tengill \xE1 vefsl\xF3\xF0"
  },
  links_14b70841: {
    message: "Tenglar"
  },
  load_more_results_460f49a9: {
    message: "Hla\xF0a fleiri ni\xF0urst\xF6\xF0um"
  },
  loading_25990131: {
    message: "Hle\xF0ur..."
  },
  loading_failed_b3524381: {
    message: "Mist\xF3kst a\xF0 hla\xF0a..."
  },
  loading_folders_8d4d5d5a: {
    message: "Hle\xF0 inn skr\xE1m..."
  },
  modules_c4325335: {
    message: "Einingar"
  },
  no_results_940393cf: {
    message: "Engar ni\xF0urst\xF6\xF0ur."
  },
  pages_e5414c2c: {
    message: "S\xED\xF0ur"
  },
  people_b4ebb13c: {
    message: "F\xF3lk"
  },
  quizzes_7e598f57: {
    message: "Pr\xF3f"
  },
  record_upload_media_5fdce166: {
    message: "Taka/hla\xF0a upp margmi\xF0lunarefni"
  },
  rich_text_area_press_alt_f8_for_help_58f0f2c3: {
    message: "Sv\xE6\xF0i me\xF0 miklum texta. \xDDti\xF0 \xE1 ALT+F8 til a\xF0 f\xE1 a\xF0sto\xF0"
  },
  search_280d00bd: {
    message: "Leita"
  },
  search_flickr_6884b518: {
    message: "Leita \xED Flickr"
  },
  select_a_file_53ba40ac: {
    message: "Velja skr\xE1"
  },
  select_a_folder_to_upload_your_file_into_b82d12b: {
    message: "Velja m\xF6ppu til a\xF0 hla\xF0a skr\xE1nni \xFEinni upp \xED"
  },
  syllabus_f191f65b: {
    message: "N\xE1msefni"
  },
  text_color_press_down_to_select_8f5ad9b5: {
    message: "Litur texta, \xFDti\xF0 ni\xF0ur til a\xF0 velja"
  },
  the_material_is_in_the_public_domain_279c39a3: {
    message: "Efni\xF0 er \xE1 opinbera l\xE9ninu"
  },
  the_material_is_licensed_under_creative_commons_3242cb5e: {
    message: "Efni\xF0 er me\xF0 leyfisveitingu hj\xE1 Creative Commons"
  },
  the_material_is_subject_to_fair_use_exception_41bc6a4b: {
    message: "R\xE9ttm\xE6t notkun \xE1 efninu er leyf\xF0"
  },
  this_upload_exceeds_the_file_storage_quota_please__c3a1b641: {
    message: "\xDEetta uppflutta efni er st\xE6rra en geymsluhluti skr\xE1a. Vinsamlegast haf\xF0u samband vi\xF0 kerfisstj\xF3rnanda \xFEinn."
  },
  upload_8b403d05: {
    message: "Hla\xF0a upp"
  },
  upload_a_new_file_96e6d4ff: {
    message: "Hla\xF0a upp n\xFDrri skr\xE1"
  },
  upload_a_new_image_890df275: {
    message: "Hla\xF0a upp n\xFDrri mynd"
  },
  usage_right_ff96f3e2: {
    message: "Notkunarr\xE9ttindi:"
  },
  what_would_you_like_to_call_the_new_page_d7e4488a: {
    message: "Hva\xF0 vilt \xFE\xFA nefna n\xFDju s\xED\xF0una?"
  },
  wiki_home_9cd54d0: {
    message: "Heimas\xED\xF0a wiki"
  }
};

_formatMessage.default.addLocale({
  is: locale
});